import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

export const DropZoneStylerProps = {
  paddingY: '3em',
  borderStyle: 'dashed',
  borderWidth: '3px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5em',
  mt: '0.5em',
  color: `${themeColors.ColorPrimary} !important`,
};
